import * as React from 'react';
// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import {FeatureCard} from './feature-card';

type Props = {
    title: string;
    description: string;
    history: RouterHistory;
    exploreLink?: string;
    thumbnailIllustration?: string;
    icon: React.ComponentType<any>;
};

/**
 * A small wrapper around the `CueCard` component for reusablility in the AI
 * homepage
 */
export function AiFeatureCard(props: Props) {
    const thumbnailBackgroundColor = props.thumbnailIllustration ? 'aiPurplePinkXlt' : undefined;
    const thumbnailBackgroundColorHover = props.thumbnailIllustration ? 'aiPurpleLt' : undefined;
    const thumbnailBackgroundGradientHover = props.thumbnailIllustration
        ? {colors: ['aiPurplePinkMd', 'aiPurplePrimary'], angle: 140}
        : undefined;

    return (
        <FeatureCard
            title={props.title}
            description={props.description}
            history={props.history}
            exploreLink={props.exploreLink}
            // @ts-expect-error
            thumbnail={
                props.thumbnailIllustration
                    ? {
                          backgroundColor: thumbnailBackgroundColor,
                          backgroundColorHover: thumbnailBackgroundColorHover,
                          backgroundGradientHover: thumbnailBackgroundGradientHover,
                          illustration: props.thumbnailIllustration,
                      }
                    : undefined
            }
            variant='ai'
            icon={props.icon}
        />
    );
}
